export enum PortCallStatusEnum {
    Departed,
    Arrived,
    Planned,
    Hidden,
}
